import { useState } from "react";
import { EmptyState } from "../components/ui/EmptyState";
import { ReasonModal } from "../components/ui/ReasonModal";
import { SegmentedControl } from "../components/ui/SegmentedControl";
import { Select } from "../components/ui/Select";
import { StatTile } from "../components/ui/StatTile";

/**
 * G-9.2 done-means: a temporary owner-only gallery rendering every kit
 * component in the CURRENT theme (flip it from Profile → Appearance to check
 * the other). DELETE this route once the G-9.3 page migrations are finished.
 */
export function KitPreviewPage() {
  const [period, setPeriod] = useState<"today" | "30d" | "custom">("30d");
  const [reasonOpen, setReasonOpen] = useState<"required" | "optional" | "none" | null>(null);
  const [lastConfirm, setLastConfirm] = useState<string>("—");

  return (
    <section className="page-stack">
      <div>
        <h2>Component kit preview</h2>
        <p className="muted">
          Temporary gallery (G-9.2). Check it in BOTH themes via Profile →
          Appearance. Delete after the page migrations.
        </p>
      </div>

      <div className="card">
        <strong>Buttons — system A · Filled &amp; Tinted (owner choice, OD-10)</strong>
        <div className="button-row">
          <button type="button" className="button">
            Primary
          </button>
          <button type="button" className="button tinted">
            Secondary
          </button>
          <button type="button" className="button plain">
            Plain
          </button>
          <button type="button" className="button danger">
            Destructive
          </button>
        </div>
      </div>

      <div className="card">
        <strong>Stat tiles</strong>
        <div className="kit-preview-grid">
          <StatTile label="Revenue" value="€909.00" tone="positive" />
          <StatTile
            label="Profit before running costs, with IVA"
            value="-€81.52"
            tone="negative"
            hint="After cost of goods, courier payouts & commission"
          />
          <StatTile label="Inventory purchased" value="€3,713.39" />
          <StatTile label="Waste losses" value="€32.00" tone="warning" hint="Last 30 days" />
        </div>
      </div>

      <div className="card">
        <strong>Segmented control</strong>
        <div>
          <SegmentedControl
            ariaLabel="Period"
            value={period}
            onChange={setPeriod}
            options={[
              { value: "today", label: "Today" },
              { value: "30d", label: "Last 30 days" },
              { value: "custom", label: "Custom" },
            ]}
          />
        </div>
      </div>

      <div className="card">
        <strong>Select</strong>
        <div className="button-row">
          <Select defaultValue="corsega" aria-label="Shop">
            <option value="corsega">Còrsega (CORSEGA)</option>
            <option value="second">Second shop</option>
          </Select>
        </div>
      </div>

      <div className="card">
        <strong>Reason modal</strong>
        <p className="muted">Last confirm: {lastConfirm}</p>
        <div className="button-row">
          <button type="button" className="button danger" onClick={() => setReasonOpen("required")}>
            Required reason
          </button>
          <button type="button" className="button tinted" onClick={() => setReasonOpen("optional")}>
            Optional reason
          </button>
          <button type="button" className="button plain" onClick={() => setReasonOpen("none")}>
            Plain confirm
          </button>
        </div>
      </div>

      <div className="card">
        <strong>Empty state</strong>
        <EmptyState
          title="Nothing here yet"
          message="When there is data, it appears in this space."
          action={
            <button type="button" className="button tinted">
              Do the thing
            </button>
          }
        />
      </div>

      {reasonOpen ? (
        <ReasonModal
          title="Demo confirmation"
          message="This is the kit ReasonModal — it replaces every native browser dialog."
          reasonMode={reasonOpen}
          confirmLabel="Confirm"
          destructive={reasonOpen === "required"}
          onConfirm={(reason) => {
            setLastConfirm(reason ?? "(no reason)");
            setReasonOpen(null);
          }}
          onClose={() => setReasonOpen(null)}
        />
      ) : null}
    </section>
  );
}
